import { DEFAULT_ANALYTICS_FILTERING } from '../../../../utils/constants'
import createFiltersStore from '../../../../stores/createFiltersStore'

export const useAnalyticsFiltersStore = createFiltersStore(
    'activeAnalyticsFilters',
    DEFAULT_ANALYTICS_FILTERING
)
